import type {
  CinnamonWebSocketFactory,
  APIConfig,
} from '@/apis/infrastructures'

export const createCinnamonWebSocketFactory = (
  config: APIConfig
): CinnamonWebSocketFactory => {
  const { cinnamonWsUrl, apiToken } = config
  return (roomId: number, entranceGUID: string) => {
    const query =
      entranceGUID.length > 0 ? `?entrance-guid=${entranceGUID}` : ''
    return new WebSocket(
      `${cinnamonWsUrl}/ws/${roomId}${query}`,
      apiToken ? encodeURIComponent(apiToken.toString()) : undefined
    )
  }
}
